import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function TwitterIcon({ fill = '#1E1E1E', icon = '#FFF' }) {
    return (
        <SvgIcon sx={{ width: { xs: 44, md: 48 }, height: { xs: 44, md: 48 } }}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill={fill} />
                <g clipPath="url(#clip0_20418_8250)">
                    <path
                        d="M26.2326 22.1571L34.9706 12H32.9L25.3128 20.8193L19.253 12H12.2637L21.4273 25.3364L12.2637 35.9877H14.3344L22.3466 26.6742L28.7463 35.9877H35.7356L26.2321 22.1571H26.2326ZM23.3965 25.4538L22.468 24.1258L15.0805 13.5588H18.261L24.2228 22.0867L25.1513 23.4147L32.9009 34.4998H29.7204L23.3965 25.4544V25.4538Z"
                        fill={icon}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_20418_8250">
                        <rect width="23.4719" height="24" fill="white" transform="translate(12.2637 12)" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );
}
